// import {
//   useDashboardStore,
//   useSecureQuoteStore,
//   useUserCredentialsStore,
// } from "@/stores";
// import { useNavigate } from "react-router-dom";
import { WEBFLOW_BASE_URL } from "@/utils";
import { Button } from "./ui/button";

export const SubmitNewQuote = () => {
  // const navigate = useNavigate();

  // const clearErrorState = useDashboardStore((s) => s.clearErrorState);
  // const clearWarnState = useDashboardStore((s) => s.clearWarnState);
  // const removeAllPrograms = useDashboardStore((s) => s.removeAllPrograms);
  // const setAverageRate = useDashboardStore((s) => s.setAverageRate);
  // const setTotalSanitizedMiles = useDashboardStore(
  //   (s) => s.setTotalSanitizedMiles,
  // );
  // const setTotalPayout = useDashboardStore((s) => s.setTotalPayout);
  // const setIsCreatingNewQuote = useDashboardStore(
  //   (s) => s.setIsCreatingNewQuote,
  // );

  // const clearQuoteIds = useSecureQuoteStore((s) => s.clearQuoteIds);

  // const clearPartiallyProfile = useUserCredentialsStore(
  //   (s) => s.clearPartiallyProfile,
  // );
  // const handleSubmitNewQuote = () => {
  //   clearErrorState();
  //   clearWarnState();
  //   removeAllPrograms();
  //   setAverageRate(0);
  //   setTotalSanitizedMiles(0);
  //   setTotalPayout({
  //     baseAmount: 0,
  //     statusBonusAmount: 0,
  //     totalPayout: 0,
  //   });

  //   clearQuoteIds();
  //   clearPartiallyProfile();

  //   setIsCreatingNewQuote(true);
  //   navigate("/dashboard");
  // };
  return (
    <div className="flex flex-col xl:flex-row xl:justify-between bg-custom-light-blue/60 rounded-lg py-5 w-full md:gap-24 px-[10%]">
      <img src="/checkout-success/illustration.svg" />

      <div className="flex flex-col gap-6">
        <p className="text-center text-[32px] md:text-5xl font-bold">
          Want to sell or buy more miles?
        </p>

        <Button
          // onClick={handleSubmitNewQuote}
          onClick={() => {
            window.location.href = WEBFLOW_BASE_URL;
          }}
          className="uppercase rounded-sm w-fit mx-auto px-14 py-6"
        >
          Submit new quote
        </Button>
      </div>
    </div>
  );
};
